// Éléments partagés entre la fiche parents (/fiche) et le formulaire joueur de l'Effectif.
const pill = (on, tone) => `rounded-full border px-3 py-1.5 text-sm font-semibold transition-colors ${on
  ? tone === "signal" ? "border-signal bg-signal text-ink" : "border-lime bg-lime text-ink"
  : `border-line bg-ink text-chalk ${tone === "signal" ? "hover:border-signal" : "hover:border-lime"}`}`;

export const OuiNon = ({ label, value, onChange, testid }) => (
  <div role="radiogroup" aria-label={label} className="flex flex-wrap items-center gap-2">
    <span className="mr-auto text-sm text-chalk">{label}</span>
    {[["oui", "Oui"], ["non", "Non"]].map(([k, l]) => (
      <button key={k} type="button" role="radio" aria-checked={value === k} data-testid={`${testid}-${k}`} onClick={() => onChange(value === k ? "" : k)} className={`${pill(value === k)} min-w-[64px]`}>{l}</button>
    ))}
  </div>
);

// Libellé d'un responsable pour le choix du contact d'urgence : « Resp. 1 · Maman (Anne) ».
const respLabel = (n, lien, nom) => `Resp. ${n}${lien ? ` · ${lien}` : ""}${nom ? ` (${nom})` : ""}`;

export const UrgenceChoice = ({ value, onChange, r1, r2, testid }) => (
  <div className="grid gap-2 sm:grid-cols-3">
    <button type="button" data-testid={`${testid}-resp1`} aria-pressed={value === "resp1"} onClick={() => onChange(value === "resp1" ? "" : "resp1")} className={pill(value === "resp1", "signal")}>{respLabel(1, r1.lien, r1.nom)}</button>
    <button type="button" data-testid={`${testid}-resp2`} aria-pressed={value === "resp2"} disabled={!r2.nom && !r2.tel} onClick={() => onChange(value === "resp2" ? "" : "resp2")} className={`${pill(value === "resp2", "signal")} disabled:cursor-not-allowed disabled:opacity-40`}>{respLabel(2, r2.lien, r2.nom)}</button>
    <button type="button" data-testid={`${testid}-autre`} aria-pressed={value === "autre"} onClick={() => onChange(value === "autre" ? "" : "autre")} className={pill(value === "autre", "signal")}>Autre personne</button>
  </div>
);

// Anciennes valeurs « papa » / « maman » converties vers le responsable correspondant.
export const urgenceChoixActuel = (f) => {
  const lien = { papa: "Papa", maman: "Maman" }[f.urgence_choix];
  if (!lien) return f.urgence_choix;
  if (f.resp1_lien === lien) return "resp1";
  if (f.resp2_lien === lien) return "resp2";
  return "";
};
